import { CustomerAddresses } from '@src/containers/Dealer/CustomerAddresses';
import type { CustomerAddressesPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { EntityAdminPanelShell } from './EntityAdminPanelShell';

export function CustomerAddressesPanel({ api, params }: LayoutPanelProps<CustomerAddressesPanelConfig>) {
  return (
    <EntityAdminPanelShell
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-addresses-panel"
    >
      <CustomerAddresses />
    </EntityAdminPanelShell>
  );
}
